import { SettingsManagerWatermark } from '@/components/webcomponents/SettingsManager/types/SettingsManager.type.watermark'
import type {} from '@/components/webcomponents/Global/global'

export function getWatermarkMarkup(
  disableWatermarkAttribute: boolean,
  allowAudit: boolean = false,
): string {
  try {
    if (disableWatermarkAttribute) {
      return ''
    }
    const watermarkType = getWatermarkType()
    document.AscendAwesome?.LogManager?.logInfo('watermark type:', watermarkType)
    return createWatermark(watermarkType, allowAudit)?.outerHTML ?? ''
  } catch (e) {
    document.AscendAwesome?.LogManager?.logError('Watermark generation error - disabling:', e)
    return ''
  }
}

function getWatermarkType(): SettingsManagerWatermark {
  try {
    // Check if designsystem-webcomponents.js is loaded from demo domain
    const scriptTypes = Array.from(document.querySelectorAll('script[src]')).map((script) => {
      const src = (script as HTMLScriptElement).src

      // check asset loader first - it may have already added the assets
      if (
        src.includes('/scripts/asset-loader.js') ||
        src.includes('/scripts/bundle-example-scripts.js')
      ) {
        return SettingsManagerWatermark.Examples
      }

      if (
        src.includes('designsystem-webcomponents.js') &&
        src.startsWith('https://static-demo.trustage.com')
      ) {
        return SettingsManagerWatermark.Demo
      }

      return SettingsManagerWatermark.Default
    })

    // prioritize Examples over Demo
    if (scriptTypes.includes(SettingsManagerWatermark.Examples)) {
      return SettingsManagerWatermark.Examples
    }

    if (scriptTypes.includes(SettingsManagerWatermark.Demo)) {
      return SettingsManagerWatermark.Demo
    }
  } catch (e) {
    document.AscendAwesome?.LogManager?.logError('Watermark check error - defaulting:', e)
  }

  return SettingsManagerWatermark.Default
}

function createWatermark(watermarkType: SettingsManagerWatermark, allowAudit: boolean) {
  if (watermarkType === SettingsManagerWatermark.Default) {
    return null
  }

  const watermark = document.createElement('div')
  watermark.style.maxWidth = '1400px'
  watermark.style.margin = '0 auto'
  watermark.className = 'watermark'

  if (watermarkType === SettingsManagerWatermark.Examples) {
    const version = document.AscendAwesome?.version?.replace('/', '')
    watermark.innerHTML = `<!-- Settings Manager -->
    <details>
      <summary>Ascend Awesome Design System <i>Example page</i> (expandable)</summary>
      <p>version: ${version ?? 'unknown'}</p>
      ${createAuditButton(allowAudit).outerHTML}
    </details>
      <div style="display: flex; flex-wrap: wrap; gap: 12px;">
        <div>Warning:</div>
        <div>
            Example pages load assets dynamically and will render with flickering layout shift. <br/>
            Do not do this on your site. Instead, <strong>follow the installation steps</strong>
        </div>
      </div>`
    return watermark
  } else if (watermarkType === SettingsManagerWatermark.Demo) {
    const version = document.AscendAwesome?.version?.replace('/', '')
    watermark.innerHTML = `<!-- Settings Manager -->
    <div class="watermark-content">
      <details>
      <summary>Ascend Awesome Design System <strong>Demo Assets</strong> (+)</summary>
      <p>version: ${version ?? 'unknown'}</p>
      ${createAuditButton(allowAudit).outerHTML}
      </details>
    </div>`
  }
  return watermark
}

function createAuditButton(allowAudit: boolean): HTMLElement {
  const wrapper = document.createElement('div')
  if (!allowAudit) {
    return wrapper // return empty element if audit not allowed
  }

  const button = document.createElement('button')
  button.id = 'btn-show-audit-ui'
  button.textContent = 'Show Audit UI'
  wrapper.appendChild(button)
  return wrapper
}
